<template>
    <div  class="detail-box">
        <div class="detail-title">
           <div style="float: left; margin-left: 10px; cursor: pointer;font-size:16px;font-weight: 600;">详细信息</div>
          <div style="float: right; margin-right: 10px; cursor: pointer;font-size:16px">
            <i class="el-icon-close"    @click="closeDetailBox"  />
          </div> 
        </div>
        <div class="detail-container">
           <div style="position:absolute;right:30px"><!--:src="imgurl+currLawyer.name+jpg"-->
            <!-- <img :src="imgPath?imgPath:'avatar/0.png'" alt="头像" width="100px" /> -->
            <el-image :src="imgPath" style="width: 110px;"  >
              <div slot="error">
                <img
                    src="avatar/0.png"
                    style="width: 100px;"
                />
              </div>
            </el-image>
           </div>
          <div class="lawyer-item-name" :title="currLawyer.name">姓名：{{ currLawyer.name }}</div>
          <div class="lawyer-item-stlawFirmsate"><b>律所：</b>{{ currLawyer.lawFirms }}</div>
          <div class="lawyer-item-officeLocation"><b>办公地点：</b>{{ currLawyer.officeLocation }}</div>
          <div class="lawyer-item-businessArea"><b>业务区域：</b>{{ currLawyer.businessArea }}</div>
          <div class="lawyer-item-profession"><b>专业领域：</b>{{ currLawyer.profession }}</div>
          <div class="lawyer-item-segment"><b>细分领域：</b>{{ currLawyer.segment }}</div>
          <div class="lawyer-item-qualification"><b>律师资格：</b>{{ currLawyer.qualification }}</div>
          <div class="lawyer-item-language"><b>工作语言：</b>{{ currLawyer.language }}</div>
          <div class="lawyer-item-tel"><b>联系方式：</b>{{ currLawyer.tel }}</div>
          <div class="lawyer-item-cvLink"><b>cvLink：</b><a target="_blank" style="color:blue;text-decoration:underline" :href="currLawyer.cvLink">{{ currLawyer.cvLink }}</a></div>
        </div>
      </div>
</template>
<script>
import { computed } from 'vue'
export default {
    name: 'detail',
    props: {
      currLawyer: {
      type: Object,
      default: () => {}
    },
    required:true
    },
    data() {
      return {
        imgurl:'../../assets/image/avatar/',
        jpg:'.jpg' 
      }
    },
    watch: {
      
    },
    methods: {
      //关闭详情页面
      closeDetailBox() {
        this.$emit('closeDetailBox')
      },

    },
    computed:{
      imgPath() {
      return "avatar/" + this.currLawyer.name + ".jpg";
    }
    }
  
  }
  </script>
<style lang="less" scoped>
.detail-box {
    position: fixed;
    z-index: 3000;
    top: 20px;
    right: 5px;
    width: 400px;
    height: calc(100% - 25px);
    background: rgb(255, 255, 255);
    border-radius: 3px;
    .detail-title {
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding-left: 5px;
      background: #eee;
      border-radius: 3px;
      // box-shadow: 0 2px 5px #777;
    }
    .detail-container {
      display: flex;
      flex-direction: column;
      padding: 15px;
      font-size: 14px;
      .lawyer-item-name {
        font-weight: bold;
        height: 34px;
        line-height: 34px;
        width: calc(100% - 15px);
        white-space: nowrap; /* 禁止换行 */
        overflow: hidden; /* 超出长度隐藏 */
        text-overflow: ellipsis; /* 显示省略号 */
      }
      .lawyer-item-stlawFirmsate,.lawyer-item-officeLocation,.lawyer-item-businessArea,.lawyer-item-profession,
      .lawyer-item-segment,.lawyer-item-qualification,.lawyer-item-language,.lawyer-item-tel,.lawyer-item-cvLink{
        line-height: 34px;
        width: calc(100% - 10px);
        word-wrap:break-word;
      }

      .lawyer-item-state,.lawyer-item-country, .lawyer-item-org, .lawyer-item-position, .lawyer-item-tel, .lawyer-item-email, .lawyer-item-domain, .lawyer-item-repEngName {
        // height: 25px;
        line-height: 34px;
        width: calc(100% - 10px);
        
      }
    }
  }
</style>